import { render, staticRenderFns } from "./DescuentoParams.vue?vue&type=template&id=e6141024&scoped=true&"
import script from "./DescuentoParams.vue?vue&type=script&lang=js&"
export * from "./DescuentoParams.vue?vue&type=script&lang=js&"
import style0 from "./DescuentoParams.vue?vue&type=style&index=0&id=e6141024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6141024",
  null
  
)

export default component.exports